import styled from 'styled-components';

import {
  SkeletonBody,
  SkeletonButton as InnerSkeletonButton,
} from '@xing-com/skeleton';

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: solid 1px var(--xdlColorBorderSoft);
  border-radius: 4px;
  margin-right: var(--spaceM);
  align-items: baseline;
  justify-content: space-between;
  height: 336px;
  max-width: calc(100% / 3);
  padding: 20px;
  margin-top: var(--spaceM);
  div:first-child {
    width: 100%;
  }
  &.skeletonWrapperLoggedIn {
    min-width: 100%;
  }
  &.skeletonWrapperLastItem {
    height: 280px;
    min-width: 170px;
    justify-content: flex-end;
    padding: var(--spaceM);
    margin-top: var(--spaceXXS);
  }

  &.skeletonWrapperLoggedout {
    height: 280px;
    min-width: 170px;
    padding: var(--spaceM);
    margin-top: var(--spaceXXS);

    div:first-child {
      width: 100%;
    }
  }
`;

export const SkeletonProfileInfoLastItem = styled(SkeletonBody)`
  margin-bottom: 113px;
  width: 100%;
  margin-bottom: 80px;
  margin-right: var(--spaceL);
  margin-top: var(--spaceM);
`;

export const SkeletonWrapperIndustries = styled.div`
  display: flex;
  width: 100%;
  max-width: calc(100% / 5);
  align-items: center;
  margin-right: var(--spaceM);
`;

export const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: 740px) {
    flex-wrap: unset;
  }
`;

export const SkeletonHeader = styled(SkeletonBody)`
  margin-top: var(--spaceM);
  width: 150px;
`;

export const SkeletonRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: var(--spaceXXL);
  &.skeletonRowIndustries {
    margin-bottom: 113px;
  }
`;

export const RelativeWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AbsoluteWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 8px;
`;

export const SkeletonProfileInfo = styled.div`
  width: 100%;
  margin-bottom: var(--spaceL);
  margin-right: var(--spaceL);
  margin-top: var(--spaceM);
`;

export const SkeletonButton = styled(InnerSkeletonButton)`
  width: 100px;
  height: 20px;
  align-self: center;
`;
